import { DexieFilterField, IDexieFilterField } from '@/models/dexie/DexieFilterField';

export interface IDexieFilter {
    /**
     * Dexie field id
     */
    id?: number;
    /**
     * Uuid of the filter
     */
    filterUuid: string;
    /**
     * Name of the filter, typed in by user
     */
    filterName: string;
    /**
     * ISO Date string of creation date
     */
    createdAt: string;
    /**
     * User name of creator
     */
    createdBy: string;
    /**
     * User id, not used yet
     */
    userId: string;
    /**
     * List of filter values set
     */
    data: IDexieFilterField[];

    /**
     * Used locally to check if new or changed filter was
     * already synced successfully
     */
    isSynched?: boolean;
    /**
     * Used locally to check if fitler should be removed
     * on next sync
     */
    removeOnSync?: boolean;
    /**
     * Used locally to check if fitler is unsaved
     */
    isUnsaved?: boolean;
}

export class DexieFilter implements IDexieFilter {
    public id?: number;

    public filterUuid: string;
    public filterName: string;
    public createdAt: string;
    public createdBy: string;
    public userId: string;
    public data: DexieFilterField[];

    public isSynched?: boolean;
    public removeOnSync?: boolean;
    public isUnsaved?: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieFilter);
    constructor(obj?: any) {
        // do not set id to undefined or dexie.js will throw an error
        if (obj && obj.id) {
            this.id = obj && obj.id;
        }

        this.filterName = (obj && obj.filterName) || '';
        this.filterUuid = (obj && obj.filterUuid) || '';
        this.userId = (obj && obj.userId) || '';
        this.createdBy = (obj && obj.createdBy) || '';
        this.createdAt = (obj && obj.timeStamp) || (new Date()).toISOString();
        this.isSynched = obj && obj.isSynched ? obj.isSynched : false;
        this.removeOnSync = obj && obj.removeOnSync ? obj.removeOnSync : false;
        this.isUnsaved = obj && obj.isUnsaved ? obj.isUnsaved : false;

        this.data = [];
        if (obj && obj.data) {
            (obj.data as DexieFilterField[]).forEach((filter) => {
                this.data.push(new DexieFilterField(filter));
            });
        }
    }

    public SetValues(inFilter: DexieFilter): void {
        this.filterName = inFilter.filterName;
        this.filterUuid = inFilter.filterUuid;
        this.userId = inFilter.userId;
        this.createdBy = inFilter.createdBy;
        this.createdAt = inFilter.createdAt;
        this.isSynched = inFilter.isSynched;

        this.data = [];
        for (const dataItem of inFilter.data) {
            this.data.push(new DexieFilterField(dataItem));
        }
    }
}
